import { render } from "./form-actions.vue?vue&type=template&id=e23043e2"
import script from "./form-actions.vue?vue&type=script&lang=js"
export * from "./form-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__